<template>
    <div>
      <nav class="bg-gray-900 flex justify-between items-center px-8 py-4 border-b border-gray-800">
        <div class="flex space-x-6">
          <router-link to="/" class="text-gray-100 hover:text-blue-400 transition-colors">Dashboard</router-link>
          <router-link to="/new-videos" class="text-gray-100 hover:text-blue-400 transition-colors">New Videos</router-link>
          <router-link to="/articles" class="text-gray-100 hover:text-blue-400 transition-colors">Articles</router-link>
          <router-link to="/export" class="text-gray-100 hover:text-blue-400 transition-colors">Export</router-link>
          <router-link to="/stats" class="text-gray-100 hover:text-blue-400 transition-colors">Stats</router-link>
          <router-link to="/influencers" class="text-gray-100 hover:text-blue-400 transition-colors">Influencers</router-link>
          <router-link to="/tags" class="text-gray-100 hover:text-blue-400 transition-colors">Tags</router-link>
        </div>
        <div class="flex items-center space-x-4">
          <TokenSettings />
          <span class="text-gray-400 text-sm">{{ userEmail }}</span>
          <button 
            @click="handleLogout" 
            class="bg-gray-800 hover:bg-blue-700 text-gray-400 px-4 py-2 rounded-md text-sm font-medium transition-colors shadow"
          >
            Wyloguj
          </button>
        </div>
      </nav>
      <div v-if="authError" class="px-8 py-4 bg-gray-900 border-b border-gray-800">
        <ApiAuthBanner :message="authError" @dismiss="dismissAuthError" />
      </div>
      <slot/>
    </div>
  </template>
  
<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { signOut, onAuthStateChanged } from 'firebase/auth';
import { auth } from '@/firebase/config';
import TokenSettings from '@/components/TokenSettings.vue';
import ApiAuthBanner from '@/components/ApiAuthBanner.vue';
import { useApiAuthState } from '@/composables/apiClient';

const router = useRouter();
const userEmail = ref('');
const { authError, dismissAuthError } = useApiAuthState();

onMounted(() => {
  onAuthStateChanged(auth, (user) => {
    if (user) {
      userEmail.value = user.email;
    }
  });
});

const handleLogout = async () => {
  try {
    await signOut(auth);
    router.push({ name: 'Login' });
  } catch (error) {
    console.error('Błąd podczas wylogowania:', error);
  }
};
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #f3f4f6;
  background-color: #111827;
}
nav {
  padding: 30px;
  text-align: left;
}
nav a {
  font-weight: bold;
  color: #f3f4f6;
  margin-right: 10px;
}
nav a.router-link-exact-active {
  color: #60a5fa;
}
nav a:hover {
  color: #60a5fa;
  transition-duration: .3s;
}
</style>